export default __webpack_public_path__ + "static/hitech-betting-solutions-1fa059c77114375b4913470669442943.png";